import React from "react"
import PropTypes from "prop-types"
import RatingBadge from "@components/RatingBadge/RatingBadge"
import Tag from "@components/Tag/Tag"
import ImageLoader from "@components/ImageLoader/ImageLoader"
import { getAssetPath, sanitizer } from "@commonUtils"
import css from "./LabSearchTile.scss"

const chevronIcon = getAssetPath("svgs/icons/chevron-right_18px_primary.svg")
const locationIcon = getAssetPath("svgs/icons/location_18px_grey.svg")
const trustIcon = getAssetPath("svgs/icons/trust_18px_grey.svg")

function LabSearchTile(props) {
    const { image, tags, line1, line2, line3, line4, rating, showChevron, iconChevronHandler } = props

    const handleIconButtonClick = (e, handler) => {
        if (!handler) {
            return
        }

        e.stopPropagation()
        handler()
    }

    const renderTags = (tags) => tags.map((tag, index) => <Tag key={index} {...tag} />)

    return (
        <div className={`flex ${css.alignStart}`}>
            {image?.url && image?.alt && (
                <div className={`flex justifyCenter alignBase ${css.labImage}`}>
                    <ImageLoader src={image.url} title={image?.alt} alt={image?.alt} />
                </div>
            )}
            <div className={`flexColumn ${css.labBody}`}>
                {tags?.length > 0 ? <div className="flex flexWrap">{renderTags(tags)}</div> : null}
                {line1 && (
                    <div
                        className={`smallRegular textPrimary ${tags?.length ? "marginTop-4" : ""}`}
                        dangerouslySetInnerHTML={{
                            __html: sanitizer(line1),
                        }}
                    />
                )}
                {line2 && (
                    <div
                        className="xSmallRegular textSecondary"
                        dangerouslySetInnerHTML={{
                            __html: sanitizer(line2),
                        }}
                    />
                )}
                {line3 && (
                    <div className={`flex marginTop-4 ${css.alignStart}`}>
                        <div className={`${css.labLineIcon}`}>
                            <ImageLoader src={locationIcon} alt="location" title="location" />
                        </div>
                        <div
                            className="textSecondary xSmallRegular"
                            dangerouslySetInnerHTML={{
                                __html: sanitizer(line3),
                            }}
                        />
                    </div>
                )}
                {line4 && (
                    <div className={`flex marginTop-8 ${css.alignStart}`}>
                        <div className={`${css.labLineIcon}`}>
                            <ImageLoader src={trustIcon} alt="accrediations" title="accrediations" />
                        </div>
                        <div
                            className="textSecondary xSmallRegular"
                            dangerouslySetInnerHTML={{
                                __html: sanitizer(line4),
                            }}
                        />
                    </div>
                )}
                {rating?.averageRating && (
                    <div className="marginTop-4">
                        <RatingBadge
                            averageRating={rating.averageRating}
                            totalRatings={rating.totalRatings}
                            showRatingCount
                            showText
                        />
                    </div>
                )}
            </div>
            {showChevron && (
                <div className={`flex ${css.labIcon}`}>
                    <ImageLoader
                        src={chevronIcon}
                        alt="chevron"
                        onClick={(e) => handleIconButtonClick(e, iconChevronHandler)}
                    />
                </div>
            )}
        </div>
    )
}

LabSearchTile.propTypes = {
    image: PropTypes.shape({ url: PropTypes.string.isRequired, alt: PropTypes.string.isRequired }).isRequired,
    tags: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            color: PropTypes.string,
            backgroundColor: PropTypes.string,
            borderColor: PropTypes.string,
        })
    ),
    line1: PropTypes.string.isRequired,
    line2: PropTypes.string.isRequired,
    line3: PropTypes.string,
    line4: PropTypes.string,
    rating: PropTypes.shape({
        averageRating: PropTypes.number.isRequired,
        totalRatings: PropTypes.string,
        showRatingCount: PropTypes.bool,
        showText: PropTypes.bool,
    }),
    iconChevronHandler: PropTypes.func,
    showChevron: PropTypes.bool,
}

export default LabSearchTile
